export interface IReaction {
  id?: number;
  meetingNoteId: number;
  userAzureObjectId: string;
  emoji: string;
  clientName?: string;
  noteTitle?: string;
  rootMeetingNoteId?: number;
  createdAt?: string;
  isNotificationSent?: boolean;
}

export interface IReactionSummary {
  emoji: string;
  count: number;
  userAzureObjectIds: string[];
  hasCurrentUserReacted?: boolean;
  currentUserReactionId?: number;
}

// Predefined emoji options for quick reactions
export const REACTION_EMOJIS = [
  { emoji: '👍', code: 'like', label: 'Like' },
  { emoji: '❤️', code: 'heart', label: 'Love' },
  { emoji: '😂', code: 'laugh', label: 'Laugh' },
  { emoji: '😮', code: 'surprised', label: 'Surprised' },
  { emoji: '😢', code: 'sad', label: 'Sad' },
  { emoji: '😡', code: 'angry', label: 'Angry' }
];
